import { useEffect, useState } from "react";
import { _DodoDocs, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { Alert } from "../../../../../theme/Component/Alert";
import { toast } from "react-toastify";
import { Modal } from "../../../../../theme/Component/Modal";
import { VisorAnyDocument } from "../../../../../documents/VisorAnyDocument";
import { VisorPDFBase64 } from "../../../../../documents/VisorPDFBase64";

interface Props {
    _barCode:string;
    _formCode: string;
}

export const DodoInboxDocuments = ({ _formCode,_barCode }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_DodoDocs);
    const [documentList, setDocumentList] = useState<any>([]);
    const [document, setDocument] = useState<any>({});
    const [modalDoc, setModalDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getRadicado = () => {
        _single.printOut("formCode => "+_formCode);
        if(_formCode)
        instance.getDirectoryList(_formCode).then(
            (resp) => {                                
                if (resp.Data)
                    setLista(resp.Data);
                else
                    setLista([]);
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    useEffect(() => {
        getRadicado();
    }, [_formCode])

    useEffect(() => {
        if (bean.Codigo) {
            instance.getFiledListByDirectory(_barCode, bean.Codigo).then(
                (resp) => {
                    setDocumentList(resp.FileProperties)
                    console.log(resp)
                }
            ).catch(
                err => {
                    console.log(err)
                    toast.error("Error al obtener los documentos")
                }
            )
        }
    }, [bean])

    const getDocument = (doc) => {
        if (doc.Code) {

            instance.formGetBase64StringFile(doc.Code).then(
                (resp) => {
                    setAndOpen(resp)
                }
            )
        } else {
            toast.error("No se Puede Abir el Documentos")
        }
    }

    const setAndOpen = (doc: any) => {
        setDocument(doc);
        setModalDoc({ ...modalDoc, "view": true, "name": `Visor de Documento` })
    }

    return (
        <div className="row">
            <div className="col-md-4">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h4 className="titles">DIRECTORIO</h4>
                    </div>
                    <div className="col-md-12" >
                        <ul className="list-group list-group-flush border-0 mb-0"   >
                            {lista.map((document: any, index: number) => {
                                return (
                                    <li
                                        key={index}
                                        className={`list-group-item d-flex align-items-center pointer ${bean.Codigo === document.DataBeanProperties.Codigo ? "" : ""}`}
                                        style={{ borderStyle: "dashed", borderColor: "orange" }}
                                        onClick={() => { setBean(document.DataBeanProperties) }}>
                                        <div className="flex-grow-1 ms-1">
                                            <h6 className="fs-14 mb-1">{document.DataBeanProperties.Nombre}</h6>
                                        </div>
                                        <div className="flex-shrink-0 ms-2">
                                            <b>{document.DataBeanProperties.Codigo}</b>
                                        </div>
                                        <div className="flex-shrink-0 ms-1">
                                            <i className={`ri-file-2-line label-icon align-middle fs-17 `}></i>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-7">
                <div className="row">

                    {bean.Codigo ?
                        <>
                            <div className="col-md-12 text-center">
                                <h4 className="titles">
                                    {bean.Nombre}
                                </h4>
                            </div>
                            <div className="col-md-12">
                                <div className="list-group">
                                    {Array.isArray(documentList) && documentList.map((doc: any, index: number) => {
                                        return (
                                            <button onClick={() => { getDocument(doc.DataBeanProperties) }} key={index} type="button" className="list-group-item list-group-item-action" aria-current="true">
                                                <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                {doc.DataBeanProperties.Description}{doc.DataBeanProperties.Ext}
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <Modal modal={modalDoc} updateModal={setModalDoc}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-6">
                                                <p>
                                                    <strong>Tamaño del Documento:</strong> {document.Size} <br />
                                                    <strong>Tipo de Documento:</strong> {document.Ext} <br />
                                                    <strong>Fecha del Documento:</strong> {document.DocDate} <br />
                                                    <strong>Fecha de Publicación:</strong> {document.PublishDate} <br />
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <VisorPDFBase64 base64={document.Code} />
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </>
                        :
                        <div className="col-md-12">
                            <Alert children={"Seleccione un Documento para visualizar"} clase="warning text-center" />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}